<script>
// https://vuematerial.io/components/button

export default {
    name: 'dkbr-button',
    txtDescr: 'Button. Emit the "click" event on click. Default slot may be used instead of the "text" property',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: `Inner button text`,
            default: _ => '',
        },
        desc: {
            name: 'desc',
            type: String,
            txtDescr: `Helper text (description)`,
            default: _ => '',
        },
        href: {
            name: 'href',
            type: String,
            txtDescr: `Hyperlink (a tag will be used if set)`,
            default: _ => '',
        },
        target: {
            name: 'target',
            type: String,
            enum: ['_self', '_blank'],
            txtDescr: `Hyperlink target`,
            txtEnable: 'Can be used only if "href" is set',
            enabled: (v, sett) => sett.href,
            default: _ => '_self',
        },
        icon: {
            name: 'icon',
            type: String,
            txtDescr: `Button icon`,
            default: _ => '',
        },
        iconSize: {
            name: 'iconSize',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: `Icon size`,
            txtEnable: 'Can be used only if "icon" is set',
            enabled: (v, sett) => sett.icon,
            default: _ => 1,
        },
        iconSource: {
            name: 'iconSource',
            type: String,
            enum: ['gg', 'fa'],
            txtDescr: `Icon source (google, font-awesome, etc.)`,
            txtEnable: 'Can be used only if "icon" is set',
            enabled: (v, sett) => sett.icon,
            editable: _ => false,
            default: _ => 'gg',
        },
        tltpDir: {
            name: 'tltpDir',
            type: String,
            enum: ['top', 'right', 'bottom', 'left', 'none'],
            txtDescr: `Tooltip direction with helper text (description)`,
            default: _ => 'bottom',
        },
        tltpDt: {
            name: 'tltpDt',
            type: Number,
            txtDescr: `Delay for tooltip with helper text (description)`,
            default: _ => 300,
        },
        isRaised: {
            name: 'isRaised',
            type: Boolean,
            txtDescr: `Raised button`,
            default: _ => false,
        },
        isDense: {
            name: 'isDense',
            type: Boolean,
            txtDescr: `Dense button`,
            default: _ => false,
        },
        isRipple: {
            name: 'isRipple',
            type: Boolean,
            txtDescr: `Ripple effect`,
            default: _ => true,
        },
        isDisabled: {
            name: 'isDisabled',
            type: Boolean,
            txtDescr: `Disable button`,
            default: _ => false,
        },
    },
}
</script>

<template lang="pug">

md-button(
    :md-theme="isThInv ? th+'i' : th"
    :class=`{
        'md-primary': true,
        'md-raised': isRaised,
        'md-dense': isDense,
        'md-icon-button': icon,
    }`
    :href="href"
    :target="href ? target : undefined"
    :md-ripple="isRipple"
    :disabled="isDisabled")
    dkbr-tooltip(
        v-if="desc"
        :text="desc"
        :dir="tltpDir"
        :dt="tltpDt")
    dkbr-icon(
        v-if="icon"
        :th="th"
        :isThInv="isThInv"
        :name="icon"
        :size="iconSize"
        :source="iconSource")
    slot
        span {{ text }}
</template>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/button/vue/Button.vue